<template>
  <div class="weidu">
    <div class="top_btn">
      <div class="top_title">维度设置：</div>
      <el-button type="primary" @click="addtableHandel">
        <i class="el-icon-plus"></i> 新增选项维度</el-button
      >
      <div class="tisp" style="margin-left:10px">提示：每个结果需单独保存</div>
    </div>
    <el-table :data="tableData" border style="width: 100%" class="table_css">
      <el-table-column fixed prop="date" label="编号" width="80px" align="center"> </el-table-column>
      <el-table-column prop="name" label="维度名称" align="center"> </el-table-column>
      <el-table-column prop="count" label="绑定维度数" width="150px" align="center"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="100" align="center">
        <template slot-scope="scope">
          <el-button
            @click="editItem(scope.row, scope.$index)"
            type="text"
            size="small"
            >编辑</el-button
          >
          <el-button
            @click="deleteItem(scope.row, scope.$index)"
            type="text"
            size="small"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-tabs v-model="editableTabsValue" type="card" @tab-remove="removeTab">
      <el-tab-pane
        v-for="(item, index) in editableTabs"
        :key="item.name"
        :label="item.title"
        :name="item.name"
        :ref="'tab' + index"
      >
        <resultdemo ref="resultdemoRef" :tablelist="tableData" :editableTabs="editableTabs" :ids="index" :resultList="resultList[index]" v-if="isLoaded" />
      </el-tab-pane>
    </el-tabs>
    <!-- <div class="submitbtn">
      <el-button type="primary" @click="onSubmit">保存</el-button>
      <el-button>取消</el-button>
    </div> -->
    <el-dialog title="编辑数据" :visible.sync="editDialogVisible">
      <!-- 编辑表单或模态框的内容 -->
      <el-form :model="editedItem">
        <!-- 表单项 -->
        <el-form-item label="编号">
          <el-input v-model="editedItem.date"></el-input>
        </el-form-item>
        <el-form-item label="维度名称">
          <el-input v-model="editedItem.name"></el-input>
        </el-form-item>
        <el-form-item label="绑定维度数">
          <el-input v-model="editedItem.count" disabled></el-input>
        </el-form-item>

        <!-- 确认和取消按钮 -->
        <el-form-item>
          <el-button @click="saveItem" type="primary">确认</el-button>
          <el-button @click="cancelEdit">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- <div class="topic_btn">
      <el-button @click="settopic" type="primary" v-if="isDataReady2" >配置题目</el-button>
    </div> -->
  </div>
</template>

<script>
import resultdemo from "@/components/grade_demo.vue";
import { getresultList ,deleteTestResult} from "@/api/coupon"
export default {
  components: { resultdemo },
  data() {
    return {
      tableData: [],
      editableTabsValue: "1",
      editableTabs: [],
      editDialogVisible: false,
      editedItem: {},
      edIndex: -1,
      formValues: [],
      resultList:[],
      isLoaded:false
    };
  },
  props:["id","type"],
  mounted() {
    this.getresultListHandel()
    this.addtab();
  },
  computed:{
    isDataReady() {
      return this.resultList.length > 0;
    },
    isDataReady2() {
      return this.tableData.length > 0;
    }
  },
  methods: {
    editItem(row, index) {
      // 打开编辑表单或模态框，并初始化编辑的数据项
      console.log(row, index);
      this.edIndex = index;
      this.editDialogVisible = true;
      this.editedItem = Object.assign({}, row);
    },
    deleteItem(row) {
      console.log(row);
      // 删除选中的数据项
      const index = this.tableData.indexOf(row);
      console.log(index,'index');
      if(this.resultList.length != 0){
        let num = index
        let arr = this.resultList[num]
        console.log(arr);
        let data = {
        test_id:this.id,
        result_id:arr.id
      }
      deleteTestResult(data).then((res)=>{
        console.log(res);
        if(res.code ==1){
          this.$message({
            message: "恭喜你，删除成功",
            type: "success",
          });
        }else{
          setTimeout(()=>{
            location.reload();
          },1000)
        }
      })
      }
      if (index > -1) {
        this.tableData.splice(index, 1);
        // this.editableTabs.splice(index, 1);
        this.removeTab(this.editableTabs[index].name);
        // console.log(this.tableData,'更改后的' );
      }
    },
    saveItem() {
      // 保存修改后的数据项
      const index = this.tableData.findIndex(
        (item) => item.date == this.editedItem.date
      );
      console.log(index);
      if (index > -1) {
        this.tableData.splice(index, 1, this.editedItem);
      } else {
        // this.tableData.push(this.editedItem);
        this.tableData.splice(this.edIndex, 1, this.editedItem);
        // console.log(this.editedItem);
      }
      this.editDialogVisible = false;
    },
    cancelEdit() {
      // 取消编辑
      this.editDialogVisible = false;
    },
    removeTab(targetName) {
      let tabs = this.editableTabs;
      let activeName = this.editableTabsValue;
      console.log(targetName, activeName);
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }

      this.editableTabsValue = activeName;
      this.editableTabs = tabs.filter((tab) => tab.name !== targetName);
    },
    addtab() {
      const tableDataLength = this.tableData.length;
      // 动态生成 editableTabs 长度
      const editableTabs = [];
      for (let i = 0; i < tableDataLength; i++) {
        const tab = {
          title: `结果${i + 1}`,
          name: `${i + 1}`,
          content: `Tab ${i + 1} content`,
          id:`${i+1}`
        };
        editableTabs.push(tab);
        this.editableTabs = editableTabs;
      }
      console.log(tableDataLength);
    },
    addtableHandel() {
      // 在这里执行新增数据的逻辑
      let num =this.tableData.length
      const newData = {
        // 新增数据项的字段值
        date: num+1,
      };

      // 将新增的数据添加到表格数据数组中
      this.tableData.push(newData);
      this.addtab();
    },
    getresultListHandel(){
      let data = {
        test_id:this.id
      }
      getresultList(data).then((res)=>{
        console.log(res);
        this.resultList = res.data
        this.handleLoadingComplete()
        this.tableData.length = this.resultList.length
        this.addtab() 
        this.tableData =  this.resultList.map((item, index) => {
  return {
    date: index + 1, // 将索引值加1作为`date`属性的值，从1开始累加
    name: item.title, // 将接口返回的`title`赋值给`name`
    count: item.count, // 绑定维度数
  };
});
      })
    },
    settopic(){
      this.$router.push("/appraisal/topic" + "?id=" + this.id + "&result_type=" + this.type);
    },
    handleLoadingComplete() {
      // 根据你的实际情况进行判断，如果所有接口都加载完毕，将isLoaded设置为true
      this.isLoaded = true;
    }
  },
};
</script>

<style>
.weidu {
  padding: 20px;
  box-sizing: border-box;
}
.top_btn {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}
.top_title {
  font-size: 14px;
}
.table_css{
  text-align: center;
}
</style>